<template>
  <div v-if="info" class=" order-item">

    <div class="item-head h-47 pl-40 pr-40 fslh-47 flex flex-j-sb">
      <div class="">
        <span class="fs-12 f-c-b3">订单编号：</span>
        <span class="fs-12 f-c-b1">{{ info.orderCode }}</span>
        <span class="ml-20 fs-12 f-c-b3">下单时间：</span>
        <span class="fs-12 f-c-b1">{{ info.createTime }}</span>

        <span class="fs-12 f-c-b3 ml-20">预约取件时间：</span>
        <span v-if="!showTime" class="fs-12 f-c-b1">{{ info.startDate }}&nbsp;~&nbsp;{{ info.endDate }}</span>
        <!-- <span v-if="!showTime && +info.orderState === 100" class="pointer f-c-blue ml-20" @click="showTime = true">修改</span> -->
        <ChangeTime v-if="showTime" style="display:inline !important" class="ml-10" :order-code="info.orderCode" :shipper-code="info.shipperCode" @cancel="showTime = false" @success="onSuccess" />
      </div>
      <div v-if="!showTime">
        <a-button v-if="+info.monitorStatus ===2 ||+info.monitorStatus ===6" type="link" @click="notify(info)">催单</a-button>
        <a-button v-if="+info.orderState === 100||+info.orderState === 102||+info.orderState === 103" type="link" @click="visible = true">取消寄件</a-button>
      </div>
    </div>
    <div class="flex a-center flex-j-sb mt-10 pl-40 pr-40 pb-30">
      <div class="w-324 bg-grey pd-20 ">
        <div class="flex a-center flex-j-sb mb-10"><span class="fs-b fs-16 f-c-b1">{{ info.fromName }} {{ info.fromMobile }}</span><div class="text-icon-s">寄</div></div>
        <div class="fs-12 mb-4 f-c-b3"><span>{{ info.fromProvinceName }}</span><span>{{ info.fromCityName }}</span><span>{{ info.fromExpAreaname }}</span></div>
        <div class="fs-12 mb-4 f-c-b3"><span>{{ info.fromProvinceName }}</span><span>{{ info.fromCityName }}</span><span>{{ info.fromExpAreaname }}</span><span>{{ info.fromAddress }}</span></div>
      </div>
      <div class="w-200 t-center">

        <img class=" " src="@/assets/home/arrow@2x.png" alt="">
        <div v-if="info.orderStateName" class="fs-24 fs-b mt-10 mb-10 ">{{ info.orderStateName }} <span v-if="info.shipperName" class="fs-14" >（{{info.shipperName }}）</span> </div>
        <div v-if="+info.orderState === 100 && info.pendingMessage&&info.pendingMessage.split('剩余：')[1]">
          <span class="fs-12 f-c-b3">距离接单剩余:</span>
          <span class="fs-12 f-c-b1">{{ info.pendingMessage&&info.pendingMessage.split('剩余：')[1] }}</span>
        </div>
        <div v-if="+info.orderState === 102||+info.orderState === 103||+info.orderState === 301"> <!-- 已分配 -->
          <div>
            <span class="fs-12 f-c-b3">快递员:</span>
            <span class="fs-12 f-c-b1">{{ info.fromPersonName }} {{ info.fromPersonMobile }}</span>
          </div>
          <div v-if="info.pickupCode">
            <span class="fs-12 f-c-b3">取件码:</span>
            <span class="fs-12 f-c-b1">{{ info.pickupCode }}</span>
          </div>
        </div>
        <div v-if="+info.orderState === 203">
          <div>
            <span class="fs-12 f-c-b3">取消时间:</span>
            <span class="fs-12 f-c-b1">{{ info.orderStateTime }} </span>
          </div>
          <div>
            <span class="fs-12 f-c-b3">取消原因:</span>
            <span class="fs-12 f-c-b1">{{ info.cancelReason||'--' }}</span>
          </div>
        </div>

      </div>
      <div class="w-324 bg-grey pd-20 ">
        <div class="flex a-center flex-j-sb mb-10"><span class="fs-b fs-16 f-c-b1">{{ info.toName }} {{ info.toMobile }}</span><div class="text-icon-r">收</div></div>
        <div class="fs-12 mb-4 f-c-b3"><span>{{ info.toProvinceName }}</span><span>{{ info.toCityName }}</span><span>{{ info.toExpAreaname }}</span></div>
        <div class="fs-12 mb-4 f-c-b3"><span>{{ info.toProvinceName }}</span><span>{{ info.toCityName }}</span><span>{{ info.toExpAreaname }}</span><span>{{ info.toAddress }}</span></div>
      </div>
    </div>
    <!-- <div class="mt-10 mb-4 h-32 fslh-32">
      <span class="fs-12 f-c-b3">预约取件时间：</span>
      <span class="fs-12 f-c-b1">{{ info.startDate }}&nbsp;~&nbsp;{{ info.endDate }}</span>
      <span v-if="!showTime" class="pointer f-c-blue ml-20" @click="showTime = true">修改取件时间</span>
      <ChangeTime v-if="showTime" class="ml-10" :order-code="info.orderCode" :shipper-code="info.shipperCode" @cancel="showTime = false" @success="onSuccess" />
    </div> -->
    <!-- <div v-if="!isListItem">
      <div class="mb-4"><span class="fs-12 f-c-b3">重      量：</span><span class="fs-12 f-c-b1">{{ info.weight||0 }}kg</span> </div>
      <div class="mb-4"><span class="fs-12 f-c-b3">快递公司：</span><span class="fs-12 f-c-b1">{{ info.shipperName }}</span> </div>
      <div class="mb-4"><span class="fs-12 f-c-b3">预估费用：</span><span class="fs-12 f-c-b1">{{ info.cost }}元</span> <span class="pointer f-c-blue" @click="$router.push('/main/send/waybill-query')">计费标准</span></div>
      <div class="mb-4"><span class="fs-12 f-c-b3">快递单号：</span><span class="fs-12 f-c-b1">{{ info.logisticCode }}</span></div>
    </div> -->
    <!-- <a-button class="cancel" @click="visible = true">取消寄件</a-button> -->
    <a-modal
      title="取消寄件"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="cancel"
      @cancel="visible = false"
    >
      <div> <a-textarea
        v-model="reason"
        placeholder="请输入取消理由"
        :auto-size="{ minRows: 3, maxRows: 5 }"
      /></div>
      <!-- <div  class="ant-form-explain">请选择快递公司</div> -->
    </a-modal>
  </div>
</template>
<script>
import ChangeTime from './changeTime'
export default {
  components: {
    ChangeTime
  },
  props: {
    info: {
      type: Object,
      default: null
    },
    isListItem: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      reason: '',
      showTime: false
    }
  },
  methods: {
    notify(i) {
      var ticketContent = +i.monitorStatus === 2 ? '此单已超时接单，请尽快通知快递员接单！' : '此单已超时揽件，请尽快通知快递员上门揽件！'
      this.$confirm({
        title: '提示',
        content: '确定催单？',
        onOk: async() => {
          const res = await this.$http({ ...this.$api.complaintAdd, origin: true }, {
            'ticketName': i.fromName,
            'ticketMobile': i.fromMobile,
            'kdnOrderCode': i.kdnOrderCode,
            'logisticCode': i.logisticCode,
            'orderCode': i.orderCode,
            'shipperCode': i.shipperCode,
            'ticketContent': ticketContent,
            'ticketType': 4
          })
          if (res.data.state === 'success') {
            this.$message.success('催单成功')
          } else {
            this.$message.error(res.data.msg)
          }
        }
      })
    },
    onSuccess() {
      this.$message.success('更新预约时间成功')
      this.showTime = false
    },
    async cancel() {
      try {
        this.confirmLoading = true
        if (!this.reason) {
          this.$message.error('原因不能为空')
          this.confirmLoading = false
          return
        }
        const res = await this.$http({ ...this.$api.orderCancel, origin: true }, {
          shipperCode: this.info.shipperCode,
          orderCode: this.info.orderCode,
          kdnOrderCode: this.info.kdnOrderCode,
          reason: this.reason
        })
        if (res.data.state === 'success') {
          this.confirmLoading = false
          this.$message.success('取消寄件成功')
          this.reason = ''
          this.visible = false
          this.$emit('cancelSuccess')
          // this.$router.replace('/main/send')
        } else {
          this.$message.error(res.data.msg)
          this.confirmLoading = false
        }
      } catch (error) {
        this.confirmLoading = false
      }
    }
  }
}
</script>
<style lang="scss" >
  .order-item{
        border: 1px solid rgba(0, 0, 0, 0.15);
        // padding: 30px 40px;
        margin: 0 20px;
        position: relative;
         .cancel{
        position: absolute;
        bottom: 30px;
        right: 40px;
    }
    .item-head{
      background: #F0F5FF;
    }
    }
</style>
